<div class="container theatre-grid">
  <div class="theatre-texte">
    <span class="eyebrow">{{ 'theatre.eyebrow' | traduire }}</span>
    <h2>{{ 'theatre.titre' | traduire }}</h2>
    <p class="intro">{{ 'theatre.intro' | traduire }}</p>

    <div class="chiffres">
      <div><span class="nombre">3 500</span><span class="label">{{ 'theatre.places' | traduire }}</span></div>
      <div><span class="nombre">1963</span><span class="label">{{ 'theatre.inauguration' | traduire }}</span></div>
      <div><span class="nombre">20</span><span class="label">{{ 'theatre.spectacles' | traduire }}</span></div>
    </div>

    <p class="note">Photos illustratives — le vrai théâtre de Sidi Dhaher n'a pas de photos
      libres de droits disponibles en ligne à ce jour.</p>
  </div>

  <div class="comparateur" (mousemove)="deplacerCurseur($event)">
    <img class="photo-jour" [src]="photoJour" alt="Théâtre le jour">
    <img class="photo-nuit" [src]="photoNuit" alt="Théâtre la nuit"
         [style.clip-path]="'inset(0 ' + (100 - position) + '% 0 0)'">
    <div class="curseur-ligne" [style.left.%]="position">
      <div class="curseur-bouton">↔</div>
    </div>
    <span class="etiquette etiquette-jour">Jour</span>
    <span class="etiquette etiquette-nuit">Nuit</span>
  </div>
</div>
